import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import Select from "react-select";
import { isEmpty, startCase } from "lodash";

import ParlayModal from "./ParlayModal";
import CustomDatePicker from "../../components/CustomDatePicker";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { formatDate, toFixedWithoutRounding ,DownlineHeader} from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useParams } from "react-router-dom";
import Pagination from "../../components/Pagination";
const styleBody = { padding: "8px 7px" };

const currencyOptions = [

  { value: "pbu", label: "USD" },

];

const legLabel = (count) =>
  count === 1
    ? "Single"
    : count === 2
      ? "Double"
      : count === 3
        ? "Treble"
        : count > 3
          ? "Accumulator"
          : "";

const ParlayBetList = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);

  const DEFAULT_FILTER = {
    page: 1,
   limit: 10,
    betType: "parlay",
    status: "",
    keyword: "",
    stake: "",
    userType: user?.userType,
    id: user?._id,
    fromPeriod: moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss"),
    toPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [data, setData] = useState({});
  const [show, setShow] = useState(false);
  const [selectedBets, setSelectedBets] = useState([]);

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.betHistory,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      setData(response_users.results);
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.page, filter.limit]);
  const handlePageChange = (newPage) =>
    setFilter((prev) => ({ ...prev, page: newPage }));

  const applyPreset = (preset) => {
    const fromPeriod =
      preset === "today"
        ? moment().startOf("day")
        : moment().subtract(1, "day").startOf("day");
    const toPeriod =
      preset === "today"
        ? moment().endOf("day")
        : moment().subtract(1, "day").endOf("day");
    const nextFilter = {
      ...filter,
      fromPeriod: fromPeriod.format("YYYY-MM-DD HH:mm:ss"),
      toPeriod: toPeriod.format("YYYY-MM-DD HH:mm:ss"),
    };
    setFilter(nextFilter);
    getData(nextFilter);
  };

  const handleShowDefault = () => {
    setFilter(DEFAULT_FILTER);
    if (filter.page === DEFAULT_FILTER.page && filter.limit === DEFAULT_FILTER.limit) {
      getData(DEFAULT_FILTER);
    }
  };

  const handleStatusChange = (e) =>
    setFilter((prev) => ({ ...prev, status: e.target.value }));
  const handleLimitChange = (e) =>
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  const handleStakeChange = (e) =>
    setFilter((prev) => ({ ...prev, stake: e.target.value }));
  const handleKeywordChange = (e) =>
    setFilter((prev) => ({ ...prev, keyword: e.target.value }));
  const handleCurrencyChange = (selected) =>
    setFilter((prev) => ({ ...prev, currency: selected?.value || "" }));

  const openBetsList = (item) => {
    setSelectedBets(item?.bets || []);
    setShow(true);
  };

  const rows = data?.data || [];
  const totalRecords = data?.totalDocs || 0;
  const pageTotalPL = rows.reduce((sum, item) => {
    if (!item?.isDeclared) return sum;
    return (
      sum +
      (item.result === "loss"
        ? -Number(item?.loseAmount || 0)
        : Number(item?.profitAmount || 0))
    );
  }, 0);

  return (
    <app-parlay-list-bets className="ng-star-inserted">
      <div className="full-wrap" style={{ height: "calc(100% - 105px)" }}>
        <div className="over-wrap">
          <div className="total_all">
            <h2>Parlay Bets list</h2>
            <div className="spacer" />
            <span className="total-users">
              {" "}
              Total Records: <strong>{totalRecords}</strong>
            </span>
            &nbsp;{" "}
            <span className="total-users">
              {" "}
              Page Total PL:{" "}
              <strong className={pageTotalPL < 0 ? "loss-text" : "profit-text"}>
                {toFixedWithoutRounding(pageTotalPL)}{" "}
              </strong>
            </span>
          </div>
          <div className="function-wrap funwrap">
            <ul className="input-list contentclass">
              <div id="statusCondition">
                <li>
                  <label>Bet Status:</label>
                </li>
                <li>
                  <select
                    name="betStatus"
                    id="betStatus"
                    value={filter.status}
                    onChange={handleStatusChange}
                  >
                    <option value="">All</option>
                    <option value="completed">Settled</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="voided">Voided</option>
                  </select>
                </li>
              </div>
              <li>
                <label>Period:</label>
              </li>
              <CustomDatePicker
                type="new"
                filter={filter}
                setFilter={setFilter}
              />
              <div className="diaplayflex divblock">
                <li className="widthfull">
                  <a
                    id="today"
                    className="btn widthfull"
                    onClick={(e) => {
                      e.preventDefault();
                      applyPreset("today");
                    }}
                  >
                    Just for today
                  </a>
                </li>
                <li className="widthfull">
                  <a
                    id="yesterday"
                    className="btn widthfull"
                    onClick={(e) => {
                      e.preventDefault();
                      applyPreset("yesterday");
                    }}
                  >
                    From yesterday
                  </a>
                </li>
              </div>
              <li style={{ display: "none" }}>(Time Zone:IST)</li>
              <div className="diaplayflex divblock">
                <li className="widthfull">
                  <a
                    id="showDefault"
                    className="btn-send"
                    onClick={(e) => {
                      e.preventDefault();
                      handleShowDefault();
                    }}
                  >
                    Show Default
                  </a>
                </li>
                <li className="widthfull">
                  <a
                    id="getHistory"
                    className="btn-send"
                    onClick={(e) => {
                      e.preventDefault();
                      getData(filter);
                    }}
                  >
                    Get History
                  </a>
                </li>
              </div>
              <div className="diaplayflex divblock">
                <li>
                  <label>Last:</label>
                  <select
                    name="limit"
                    id="limit"
                    value={filter.limit}
                    onChange={handleLimitChange}
                  >
                    <option value={10}>10 Txn</option>{" "}
              <option value={25}>25 Txn</option>{" "}
              <option value={50}>50 Txn</option>
              <option value={100}>100 Txn</option>
                  </select>
                </li>
                <li>
                  <label> Stake</label>
                  <input
                    type="number"
                    name="Volume Check"
                    placeholder="Volume"
                    value={filter.stake}
                    onChange={handleStakeChange}
                  />
                </li>
              </div>
            </ul>
            <ul className="input-list contentclass">
              <div className="diaplayflex divblock">
                <li>
                  <input
                    appinputrestriction="noSpecialChars3"
                    type="text"
                    placeholder="Search betId"
                    value={filter.keyword}
                    onChange={handleKeywordChange}
                  />
                </li>
              </div>

              <div className="diaplayflex1 divblock">
                <li className="widthfull">
                  <Select
                    options={currencyOptions}
                    placeholder="Select Currency"
                    isSearchable={true}
                    isClearable={true}
                    className="widthfull"
                    classNamePrefix="ng"
                    onChange={handleCurrencyChange}
                  />
                </li>
              </div>
              <li></li>
            </ul>
          </div>
          <div className="total_all">
            <span />
            <div className="spacer" />
          </div>
          <div className="table-responsive data-table">
            <div id="report">
              <table
                id="table_DL"
                className="table-s"
                style={{ display: "table" }}
              >
                <tbody>
                  <tr>
                    {DownlineHeader(user?.userType)?.map((res) => {
                                            return (
                                              <th
                                                _ngcontent-serverapp-c84
                                                width="5%"
                                                data-order="asc"
                                                data-name="playerId"
                                                className="align-L sort_asc ng-star-inserted"
                                              >
                                                {" "}
                                                {res?.value} ID{" "}
                                              </th>
                                            );
                                          })}
                    <th width="5%" className="align-L sort_asc">
                      {" "}
                      Bet ID
                    </th>
                    <th id="betTime" width="6%" className="align-L sort_asc">
                      Bet taken{" "}
                    </th>
                    <th id="betTime" width="7%" className="align-L sort_asc">
                      Bet Settled
                    </th>
                    <th width="7%" className="align-L sort_asc">
                      {" "}
                      IP Address{" "}
                    </th>
                    <th width className="align-L sort_asc">
                      List Bets{" "}
                    </th>
                    <th width="10%" className="align-L sort_asc">
                      Event{" "}
                    </th>
                    <th width="4%" className="align-C sort_asc">
                      {" "}
                      Type{" "}
                    </th>
                    <th width="7%" className="sort_asc">
                      Odds req{" "}
                    </th>
                    <th width="5%" className="sort_asc">
                      Stake{" "}
                    </th>
                    <th width="5%" name="profitOrLossTh" className="sort_asc">
                      {" "}
                      Profit/Loss
                    </th>
                    <th width="5%" name="status" className="sort_asc">
                      {" "}
                      Status
                    </th>
                    <th width="5%" name="remark" className="align-C sort_asc">
                      Remark
                    </th>
                  </tr>

                  {rows.length > 0 ? (
                    rows.map((item, index) => {
                      const ip =
                        (item?.ipAddress &&
                          item.ipAddress.replace("::ffff:", "")) ||
                        "-";
                      const netAmount = item?.isDeclared
                        ? item.result === "loss"
                          ? -Number(item?.loseAmount || 0)
                          : Number(item?.profitAmount || 0)
                        : 0;

                      return (
                        <tr
                          id={`matchRow${index}`}
                          key={item?._id || index}
                          className="ng-star-inserted"
                        >
                             {DownlineHeader(user?.userType)?.map((res) => {
                                                      //  console.log(item[res?.key]?.username);
                                                      return (
                                                        <td style={styleBody} className="align-L">
                                                          {item[res?.key]?.username || "N/A"}
                                                        </td>
                                                      );
                                                    })}
                          <td id="playerId" className="align-L">
                            {item?.clientName || "-"}
                          </td>
                          <td className="align-L">
                            <a id="betID" href="javascript: void(0);">
                              {item?.matchBetId}
                            </a>
                          </td>
                          <td className="align-L ng-star-inserted">
                            <span id="betPlaced" className="small-date">
                              {formatDate(item?.timeInserted, user?.timeZone)}
                            </span>
                          </td>
                          <td className="align-L ng-star-inserted">
                            <span id="betsettled" className="small-date">
                              {item?.isDeclared
                                ? formatDate(
                                    item?.settledDate || item?.updatedAt,
                                    user?.timeZone,
                                  )
                                : ""}
                            </span>
                          </td>
                          <td id="ip" className="align-L">
                            {ip}
                          </td>
                          <td id="matchSelection" className="align-L">
                            <button
                              title="List Bets"
                              className="btn"
                              onClick={() => openBetsList(item)}
                            >
                              {" "}
                              List{" "}
                            </button>
                          </td>
                          <td className="align-C">
                            <span id="matchType">
                              {" "}
                              parlay{" "}
                              <img
                                id="arrow"
                                src="/assets/images/transparent.gif"
                                className="fromto"
                                alt=""
                              />
                              <strong> {legLabel(item?.bets?.length)}</strong>
                            </span>
                          </td>
                          <td className="align-C">
                            <span id="matchType" className="parlay">
                              Parlay
                            </span>
                          </td>
                          <td id="matchOddsReq">{toFixedWithoutRounding(item?.bhav) || "-"}</td>
                          <td id="matchStake" style={{ whiteSpace: "nowrap" }}>
                            {item?.amount}{" "}
                            <strong className="ng-star-inserted">(USD)</strong>
                          </td>
                          <td>
                            {item?.isDeclared ? (
                              <span
                                id="pol"
                                className={`small-date ${netAmount < 0 ? "loss-text" : "profit-text"}`}
                              >
                                {toFixedWithoutRounding(netAmount)}
                              </span>
                            ) : (
                              <span id="pol" className="small-date">
                                ...
                              </span>
                            )}
                          </td>
                          <td>
                            <span id="pol" className="small-date">
                              {item?.isDeclared
                                ? startCase(item?.status || item?.result)
                                : "Open"}
                            </span>
                          </td>
                          <td id="remark" className="align-L"></td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={16}>
                        You have no bets in this time period.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <p className="table-other" style={{ marginTop: "5px" }}>
                {" "}
                Bet List is shown net of commission.{" "}
              </p>
            </div>
          </div>

          {rows.length > 0 && data?.totalDocs > 0 && (
            <Pagination pagination={data} onPageChange={handlePageChange} />
          )}
        </div>
      </div>
      <ParlayModal
        isOpen={show}
        onClose={() => setShow(false)}
        data={selectedBets}
      />
    </app-parlay-list-bets>
  );
};

export default ParlayBetList;
